import { Grid } from '@mui/material';
import NoGraphData from './NoGraphData';
import FertilizerFacilityBarGraph from './FertilizerFacilityBarGraph';
import FertilizerFacilityPieChart from './FertilizerFacilityPieChart';

function FertilizerGraphPairForFacilities({ barGraphData, pieChartData, groupName, year, type, unit }) {
    const EXCLUDED_GROUP_NAME = 'Vinimark Trading'
    return (
        <NoGraphData data={barGraphData} year={year} type={type} variant={'fertilizer'}>
            {groupName !== EXCLUDED_GROUP_NAME &&
                <>
                    <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                        <FertilizerFacilityBarGraph data={barGraphData} group={groupName} type={type} year={year} unit={unit} />
                    </Grid>
                    <Grid xs={12} xl={6} item display="flex" alignContent={'space-between'} mb={'3rem'}>
                        <FertilizerFacilityPieChart data={pieChartData} group={groupName} type={type} year={year} unit={unit} />
                    </Grid>
                </>
            }
        </NoGraphData>
    )
}

export default FertilizerGraphPairForFacilities;